import { StoreHelper } from "@share/web-conferences/helpers/StoreHelper";
import { LiveKitClientInterface } from "@share/live-kit/interfaces/LiveKitClientInterface";
import { DataPacket_Kind as DataPacketKind, LocalParticipant, RemoteParticipant, RoomEvent } from "livekit-client";
import { ClientDataTypes } from "@share/live-kit/enums/ClientDataTypes";
import { UserProfilesService } from "@share/web-conferences/data/UserProfilesService";

export class LiveKitDataHelper {
    encoder = new TextEncoder();
    decoder = new TextDecoder();

    constructor(
        private readonly client: LiveKitClientInterface,
        private readonly userProfilesService: UserProfilesService,
        private readonly storeHelper: StoreHelper
    ) {
        this.client.room.on(RoomEvent.DataReceived, (payload, participant) => {
            console.log('data received', payload, participant);
            if (!participant) {
                return;
            }

            this.receiveData(payload, participant);
        })
    }

    async publishData(data: string): Promise<void> {
        console.log('publishing data', data);
        try{
            const dataToSend = this.encoder.encode(data);

            // eslint-disable-next-line @typescript-eslint/camelcase
            await this.client.room.localParticipant.publishData(dataToSend, DataPacketKind.RELIABLE);
        }
        catch (e) {
            this.storeHelper.store.dispatch('reportException', e);
        }
    }

    receiveData(payload: Uint8Array, participant: LocalParticipant | RemoteParticipant) {
        console.log('data received', participant)
        const data = this.decoder.decode(payload);

        if (participant && data == ClientDataTypes.PresenterJoined) {
            this.userProfilesService.fetchProfile(parseInt(participant.identity));
            this.client.updateParticipant(participant);
            this.storeHelper.addJoinedUser(parseInt(participant.identity));
        }
    }
}